import { memo, Fragment } from 'react'
import propOr from 'ramda/src/propOr'
import LoadingButton from 'root/src/client/web/base/LoadingButton'
import submitFormHandler from 'root/src/client/logic/form/handlers/submitFormHandler'
import CustomSubmit from 'root/src/client/web/form/CustomSubmit'
import submitsConnector from 'root/src/client/logic/form/connectors/submitsConnector'
import { useApplicationState } from 'root/src/client/v2/userData/hooks/useApplicationState'
import { DELIVERY_DARE_FORM_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'

export const SubmitsUnstyled = memo(({
	// parent component
	moduleId, moduleKey, setWasSubmitted, isPostFormSubmit,
	// redux connector
	formType, formSubmits, submitForm, customSubmitsData, submitsFullWidth,
	submitsBlock, setSubmitsBlock, submitsLoading, submitsRow, postFormSubmits,
}) => {
	const submits = isPostFormSubmit ? postFormSubmits : formSubmits
	const { invalidateApplicationState } = useApplicationState()

	return (
		<Fragment>
			{submits.map(([
				label, submitIndex, submitting, buttonType, customSubmitType, icon, componentProps,
			]) => (
				<div
					style={
						submitsRow ? {
							margin: 25,
							width: 100,
							position: 'relative',
						} : { marginBottom: 15 }
					}
					key={submitIndex}
				>
					{customSubmitType
						? (
							<CustomSubmit
								customSubmitType={customSubmitType}
								submitIndex={submitIndex}
								customSubmitsData={customSubmitsData}
								componentProps={componentProps}
							/>
						)
						: (
							<LoadingButton
								disabled={submitsBlock}
								isLoading={submitting || propOr(false, submitIndex, submitsLoading)}
								loading={submitting || propOr(false, submitIndex, submitsLoading)}
								onClick={async (...params) => {
									await submitFormHandler(
										submitForm,
										moduleKey,
										submitIndex,
										setWasSubmitted,
										isPostFormSubmit,
										setSubmitsBlock,
										moduleId,
									)(...params)
									// TODO!!! this solution is terrible. rewrite delivery form to v2 and remove below solution
									if (moduleId === DELIVERY_DARE_FORM_MODULE_ID) {
										void invalidateApplicationState()
									}
								}}
								formType={formType}
								buttonType={buttonType}
								icon={icon}
								submitsFullWidth={submitsFullWidth}
								submitsBlock={submitsBlock}
							>
								{label}
							</LoadingButton>
						)
					}
				</div>
			))}
		</Fragment>
	)
})

export default submitsConnector(SubmitsUnstyled)
